import React, { useId } from "react";

import { HelperTooltip } from "../base/helper-tooltip";
import { RequiredAsterisk } from "../required-asterisk";
import { FormFieldIdProvider } from "./form-field-id-context";

export function FormField({
  label,
  tooltip,
  children,
  mandatory,
  className,
  span,
}: {
  label: React.ReactNode;
  tooltip?: React.ReactNode;
  children: React.ReactNode;
  mandatory?: boolean;
  className?: string;
  span?: number;
}) {
  const fieldId = useId();

  return (
    <div
      className={className}
      style={span ? { gridColumn: `span ${span}` } : undefined}
    >
      <label
        htmlFor={fieldId}
        className="mb-1 flex min-h-5 items-center gap-1 text-xs font-semibold"
      >
        <span>{label}</span>
        {mandatory && <RequiredAsterisk />}
        {tooltip && <HelperTooltip content={tooltip} />}
      </label>
      <FormFieldIdProvider value={fieldId}>
        <div className="flex min-h-8 w-full items-center [&>*]:w-full [&>*]:block">
          {children}
        </div>
      </FormFieldIdProvider>
    </div>
  );
}
